<div class="layout-container">
     <app-operations [isCollapsed]="isCollapsed"></app-operations>
     <div class="main-content">
          <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
          <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
               <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="fw-semibold">Sold Items Search</h5>
               </div>
               <hr />
               <div class="container-fluid py-2">
                    <form [formGroup]="soldItemSearchForm">
                         <div class="row g-2 align-items-start">
                              <div class="col-12 col-md-6 col-lg-3">
                                   <label class="form-label">From Date</label>
                                   <ejs-datepicker formControlName="fromDate"
                                        [max]="soldItemSearchForm.get('toDate')?.value"
                                        (change)="onFromDateChange($event)" cssClass="form-control p-0">
                                   </ejs-datepicker>
                              </div>

                              <div class="col-12 col-md-6 col-lg-3">
                                   <label class="form-label">To Date</label>
                                   <ejs-datepicker formControlName="toDate"
                                        [min]="soldItemSearchForm.get('fromDate')?.value"
                                        (change)="onToDateChange($event)" cssClass="form-control p-0"></ejs-datepicker>
                              </div>

                              <div class="col-12 col-md-6 col-lg-3">
                                   <label class="form-label">Terminal</label>
                                   <select class="form-select" formControlName="terminal">
                                        <option [ngValue]="">ALL</option>
                                        <option *ngFor="let t of terminals" [value]="t">{{ t }}</option>
                                   </select>
                              </div>

                              <div class="col-12 col-md-6 col-lg-3">
                                   <label class="form-label">User</label>
                                   <select class="form-select" formControlName="user">
                                        <option [ngValue]="">ALL</option>
                                        <option *ngFor="let user of userList" [value]="user">{{ user }}</option>
                                   </select>
                              </div>
                         </div>
                         <div class="card p-2 mt-2">
                              <div class="row">
                                   <div class="col-md-6 col-lg-3 text-start mt-2">
                                        <div class="form-check">
                                             <input type="radio" class="form-check-input" formControlName="vendorFilter"
                                                  id="rdAllVendors" value="false">
                                             <label class="form-check-label" for="rdAllVendors">All {{'Vendors' |
                                                  wordReplace}}</label>
                                        </div>
                                   </div>
                                   <div class="col-md-6 col-lg-3 text-start mt-2">
                                        <div class="form-check">
                                             <input type="radio" class="form-check-input" formControlName="vendorFilter"
                                                  id="rdReqVendor" (blur)="getVendorById()" value="true">
                                             <label class="form-check-label" for="rdReqVendor">Requested {{'Vendor' |
                                                  wordReplace}}</label>
                                        </div>
                                   </div>
                                   <div class="col-md-6 text-start mt-2">
                                        <div class="row">
                                             <div class="col-auto">
                                                  <label class="form-check-label ms-1 mt-1" for="vendorId">
                                                       {{'Vendor ID' | wordReplace}}
                                                  </label>
                                             </div>
                                             <div class="col-3">
                                                  <input type="text" id="vendorId"
                                                       formControlName="soldItemVendorAlphaNumericId"
                                                       class="form-control form-control-sm" />
                                             </div>
                                             <div class="col-5">
                                                  <input type="text" id="vendorName"
                                                       formControlName="soldItemVendorName"
                                                       class="form-control form-control-sm" />
                                             </div>
                                             <div class="col-auto">
                                                  <button type="button" class="btn btn-dark" (click)="openVendorModal()"
                                                       [disabled]="soldItemSearchForm.get('vendorFilter')?.value === 'false'">
                                                       <img src="./assets/images/search.svg" class="img-fluid" />
                                                  </button>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                         <div class="p-2">
                              <div class="row g-3 align-items-center">

                                   <div class="col-auto">
                                        <div class="form-check form-check-inline">
                                             <input class="form-check-input" type="radio" name="searchBy" id="byItem"
                                                  formControlName="searchBy" value="item" checked>
                                             <label class="form-check-label" for="byItem">Item Name</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                             <input class="form-check-input" type="radio" name="searchBy" id="byStock"
                                                  formControlName="searchBy" value="stock">
                                             <label class="form-check-label" for="byStock">Stock ID</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                             <input class="form-check-input" type="radio" name="searchBy" id="byPrice"
                                                  formControlName="searchBy" value="price">
                                             <label class="form-check-label" for="byPrice">Price</label>
                                        </div>
                                   </div>

                                   <div class="col-auto">
                                        <label for="soldItem" class="form-label mb-1">{{
                                             soldItemSearchForm.get('searchBy')?.value === 'stock' ? 'Sold Item ID' :
                                             'Sold Item Name' }}
                                        </label>
                                        <input type="text" class="form-control form-control-sm" id="soldItem"
                                             formControlName="itemSearch">
                                   </div>

                                   <div class="col-auto">
                                        <label for="price" class="form-label mb-1">Price</label>
                                        <input type="text" class="form-control form-control-sm" id="price"
                                             formControlName="priceSearch">
                                   </div>

                                   <div class="col-auto">
                                        <div class="form-check">
                                             <input class="form-check-input" type="checkbox" id="wholeWord"
                                                  formControlName="searchWholeWordOnly">
                                             <label class="form-check-label" for="wholeWord">Search Whole Word
                                                  Only</label>
                                        </div>
                                   </div>
                                   <div class="col-auto">
                                        <div class="form-check">
                                             <input class="form-check-input" type="checkbox" id="showAll"
                                                  formControlName="showAllSoldItems">
                                             <label class="form-check-label" for="showAll">Show all sold items</label>
                                        </div>
                                   </div>
                              </div>
                              <h6>Stock Items Particulars</h6>
                              <div class="grid-wrapper position-relative">
                                   <div class="block-ui" *ngIf="loaderIcon | async">
                                        <app-loader></app-loader>
                                   </div>
                                   <div class="col-12 text-start">
                                        <ejs-grid height='350' #gridPosSoldItemSearch [dataSource]="soldItems" (dataBound)="onGridDataBound()">
                                             <e-columns>
                                                  <e-column field="invoiceNo" headerText="Invoice #" width="120"
                                                       textAlign="Center"></e-column>
                                                  <e-column field="invoiceDate" headerText="Invoice Date" width="150"
                                                       textAlign="left" type="date" format="yMd"></e-column>
                                                  <e-column field="vendorId" headerText="{{'Vendor' | wordReplace}} ID"
                                                       width="120" textAlign="left"></e-column>
                                                  <e-column field="saleType" headerText="Sale Type" width="120"
                                                       textAlign="left"></e-column>
                                                  <e-column field="stockId" headerText="Stock ID" width="120"
                                                       textAlign="left"></e-column>
                                                  <e-column field="itemDescription" headerText="Item Description"
                                                       width="200" textAlign="left"></e-column>
                                                  <e-column field="rateUnit" headerText="Rate/Unit" width="120"
                                                       textAlign="Right"></e-column>
                                                  <e-column field="qty" headerText="Qty" width="100"
                                                       textAlign="left"></e-column>
                                                  <e-column field="terminal" headerText="Terminal" width="120"
                                                       textAlign="left"></e-column>
                                                  <e-column field="user" headerText="User" width="120"
                                                       textAlign="left"></e-column>
                                             </e-columns>
                                        </ejs-grid>

                                   </div>
                              </div>
                              <div class="row">
                                   <div class="col-12 text-end my-2">
                                        <button class="btn btn-orange" (click)="onClose()">Close</button>
                                   </div>
                              </div>
                         </div>
                    </form>
               </div>
          </div>
     </div>
     <!-- Modal with Vendor Search Component -->
     <div class="modal fade" id="vendorSearchModal" #vendorSearchModal tabindex="-1" aria-labelledby="vendorSearchLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-lg modal-dialog-centered">
               <div class="modal-content">
                    <div class="modal-header">
                         <h5 class="modal-title" id="vendorSearchLabel">
                              {{'Select Vendor' | wordReplace}}
                         </h5>
                         <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                         <app-vendor-search [isVendorPopUp]="true" [VendorFilterOption]="VendorFilterOption"
                              (vendorSearchRoute)="onVendorSelected($event)">
                         </app-vendor-search>
                    </div>
               </div>
          </div>
     </div>
</div>